// Video Play/Pause control
function vidPlayPause() {
    $("video").parent().off();
    
    $("video").parent().click(function(){
          if($(this).find(".video-playpause span").hasClass("vid-pause")) {          
             $(this).find("video")[0].pause();
             $(this).find(".video-playpause span").removeClass("vid-pause");
          } else {
             $(this).find("video")[0].play();
             $(this).find(".video-playpause span").addClass("vid-pause");
          }
    });

}

vidPlayPause();

// function playPauseVideo() {
//     let videos = document.querySelectorAll("video");
//     videos.forEach((video) => {

//         video.muted = true;

//         let playPromise = video.play();
//         if (playPromise !== undefined) {
//             playPromise.then((_) => {
//                 let observer = new IntersectionObserver(
//                     (entries) => {
//                         entries.forEach((entry) => {
//                             if (
//                                 entry.intersectionRatio !== 1 &&
//                                 !video.paused
//                             ) {
//                                 video.pause();
//                             } else if (video.paused) {
//                                 video.play();
//                             }
//                         });
//                     },
//                     { threshold: 0.8 }
//                 );
//                 observer.observe(video);
//             });
//         }
//     });
// }

// playPauseVideo();

// Video Play/Pause control END
// window.addEventListener("DOMContentLoaded", function() {   
//  vidPlayPause(); 
// }); 